<template>
    <div class="app-holder">
        <router-view></router-view>
    </div>
</template>

<style>
.app-holder {
    width: 100%;
    height: 100%;
}

.version {
    position: fixed;
    left: 10px;
    bottom: 0;
    font-size: 12px;
}
</style>
